export enum DocumentTypes {
  TEMPORARY = "temporary",
  OTHER = "autre",
  CER = "cer",
  CER_TEMPLATE = "cerTemplate",
  CGU = "cgu",
  CHARTER_COMMITMENT = "charter_commitment",
  PARTNERSHIP_CONTRACT = "contrat_partenariat",
  CONVOCATION = "convocation",
  RESUME = "cv",
  EPT = "ept",
  EPT_RENEWAL_TEMPLATE = "eptRenewalTemplate",
  EPT_REORIENTATION_TEMPLATE = "eptReorientationTemplate",
  ATTENDANCE_SHEET = "feuille_d_emargement",
  POSITIONING_SHEET = "fiche_positionnement",
  COVER_LETTER = "lettre_de_motivation",
  WORKSHOP_MAIL = "workshopMail",
  WORKSHOP_MAIL_TEMPLATE = "workshopMailTemplate",
  SOCIAL_OFFER = "socialOffer",
  TRAINING_OFFER = "trainingOffer",
  EMPLOYMENT_CONTRACT = "work_contract",
  ATTACHMENT = "attachment",
  RSA_JUSTIFICATION = "rsa_justification",
  FT_REGISTRATION_PROOF = "ft_registration_proof",
  ACCOMPANYING_ASSESSMENT = "accompanying_assessment",
  ADMINISTRATIVE_DOCUMENT = "administrative_document",
  FUP_TEMPLATE = "fupTemplate",
  FUP = "fup",
  ABSENCE_JUSTIFICATION = "absence_justification",
  COACHING_SUMMARY = "coachingSummary",
  CANDIDATE_MAIL_TEMPLATE = "candidateMailTemplate",
  SANCTION = "sanction",
  FINANCIAL_AID = "financial_aid",
}
